import React from 'react';
import Entry from '../entry';
import { Text, Flex } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '10. Recover Cleartext Document';
  const flag = 'Machine Learning Sleigh Route Finder';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Holly Evergreen] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.youtube.com/watch?v=obJdpKDpFBA'>Reversing Crypto the Easy Way</a></Flex>),
  `[Holly Evergreen Chat] On a completely unrelated note, digital rights management can bring a hacking elf down.
That ElfScrow one can really be a hassle.
It's a good thing Ron Bowes is giving a talk on reverse engineering!
That guy knows how to rip a thing apart. It's like he breathes opcodes!`,
  `[Krampus Chat] I managed to find this protected document on one of the compromised machines in our environment.
I think our attacker was in the process of exfiltrating it.
I’m convinced that it is somehow associated with the plan to destroy the holidays. Can you decrypt it?
There are some smart people in the NetWars challenge room who may be able to help us.`,
];
  const assignment = 'The Elfscrow Crypto tool is a vital asset used at Elf University for encrypting SUPER SECRET documents. We can\'t send you the source, but we do have debug symbols that you can use. Recover the plaintext content for this encrypted document. We know that it was encrypted on December 6, 2019, between 7pm and 9pm UTC. What is the middle line on the cover page? (Hint: it\'s five words) For hints on achieving this objective, please visit the NetWars room and talk with Holly Evergreen.';
  const data = useStaticQuery(graphql`
    query {
      firstPage: file(relativePath: { eq: "firstPage.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      curl: file(relativePath: { eq: "curl.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      outElves: file(relativePath: { eq: "outElves.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      e60: file(relativePath: { eq: "e60.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      insideLoop: file(relativePath: { eq: "insideLoop.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      move: file(relativePath: { eq: "move.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code10brute: file(relativePath: { eq: "code10brute.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code10decrypt: file(relativePath: { eq: "code10decrypt.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code10lcg: file(relativePath: { eq: "code10lcg.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code10strings: file(relativePath: { eq: "code10strings.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code10genkey: file(relativePath: { eq: "code10genkey.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `)
  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>As suggested in the video, let's open elfscrow.exe in IDA. On Mac I was not able to load the .pdb, so working with what I have. Let's target the low hanging fruit - strings subview. Here are the useful strings that I found:</Text>
      <Img fluid={data.code10strings.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '60vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Now we know that efscrow.exe uses DES encryption algorithm with Cipher Block Chaining mode. It's also clear that the binary is escrowing the key to the server. Does the escrow server have any hints for us? </Text>
      <Img fluid={data.curl.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>What an explicit error message! Thanks! The key is a hex string 8 bytes long. But how is it generated? In IDA let's click on the location of string 'Our miniature elves are putting together random bits for your secret key'</Text>
      <Img fluid={data.outElves.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Subroutines of interest are <code>sub_401E60</code>, <code>sub_401D90</code> and <code>sub_401DC0</code> (inside the loop that iterates 8 times, key length confirmed!).</Text>
      <Flex height='30vh' flexDirection='row'>
      <Img fluid={data.e60.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '60vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Img fluid={data.move.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '60vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Img fluid={data.insideLoop.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '40vh', width: '60vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      </Flex>
      <Text my={2}> In <code>sub_401E60</code> Windows <code>_time64</code> function is used. It generates a timestamp in seconds of current system time. Looks like the seed to "random" key generator is this timestamp. The result of <code>_time64</code> is in <code>eax</code> register, which then gets saved by the original caller on stack as an argument for <code>sub_401D90</code></Text>
      <Text my={2}> In subroutine <code>sub_401D90</code> we print the timestamp and eventually save it to <code>dword_40602C</code> memory location.</Text>
      <Text my={2}> And finally, <code>sub_401DC0</code> gets called inside the loop. It acts like a random number generator. It takes whatever is at <code>dword_40602C</code> and does some math to it, and puts it back to <code>dword_40602C</code>. On the first iteration of the loop the result of <code>_time64</code> is processed. On further iterations <code>dword_40602C</code> contains the result of previous iteration. </Text>
      <Text my={2}> When subroutine <code>sub_401DC0</code> returns, the lower byte of the result <code>al</code> is moved to appropriate slot in the key array --> <code>[ebp+arg_0]</code> is the address of the beginning of array, <code>[ebp+var_4]</code> is the current offset (it gets incremented in the loop). </Text>
      <Text my={2}>If we Google one of the numbers from RNG subroutine <code>sub_401DC0</code>, 214013, it leads us to <a href='https://rosettacode.org/wiki/Linear_congruential_generator'>Rosetta Code</a>, Linear Congruential Generator.</Text>

      <Text my={2}>To sum up what we know: elfscrow.exe uses DES-CBC encryption algorithm that needs 8 byte key. The key is produced by Linear Congruential Generator pseudo-RNG, which takes timestamp in seconds as the seed. </Text>

      <Text my={2}>Now we're ready to implement the solution in JavaScript. We will generate key and decrypt based on every possible second (timestamp) on December 6th between 7 and 9 PM.</Text>
      <Img fluid={data.code10brute.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '30vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Rosetta Code has no official JavaScript implemetation of LCG, so we will make our own function that returns a function with closure to track the seed. </Text>
      <Img fluid={data.code10lcg.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '32vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>Next we replicate the behaviour of the key generating loop.</Text>
      <Img fluid={data.code10genkey.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '32vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>The decryption function will use Node.js 'crypto' module to do DES with CBC mode. Initialization vector will be all zeros.</Text>
      <Img fluid={data.code10decrypt.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '72vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>The <code>brute()</code> takes 3 minues to execute. Here is the first page of the decrypted document!</Text>
      <Img fluid={data.firstPage.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
